import { ValueObject } from '@nx-smartmonkey/shared/domain';

interface HourChartAnalyticsProps {
  value: number;
  hour: number;
}

export class HourChartAnalytics extends ValueObject<HourChartAnalyticsProps> {
  get value(): number {
    return this.props.value;
  }
  get hour(): number {
    return this.props.hour;
  }
  private constructor(props: HourChartAnalyticsProps) {
    super(props);
  }

  static create(props: HourChartAnalyticsProps): HourChartAnalytics {
    return new HourChartAnalytics(props);
  }

  hourToString(): string {
    const timeZoneOffset = new Date().getTimezoneOffset() / 60;
    const difference = this.hour - timeZoneOffset + 24;
    const gmtHour = difference % 24;
    return `${gmtHour < 10 ? `0${gmtHour}` : gmtHour}:00`;
  }
}
